import request from '@/utils/request'

export function getPackageLogListApi(query) {
  return request({
    url: '/config-service/v1/package/package-log',
    method: 'get',
    params: query
  })
}
